import React, { useState } from 'react';
import { Spinner, Table } from 'react-bootstrap';
import { Print } from '../../../../components/atoms/icons';
import AddServiceIcon from '../../../../assets/icons/add-service.png';
import Modal from '../../../../components/organisms/modals';
import Forms from '../../../../components/organisms/forms';
import partnerByIdRes from '../../../../components/api/partner/getByIdRes.json';
import monthlyCommissionRes from '../../../../components/api/partner/getMonthlyCommissionByDateRangeAndId.json';

interface Props {
   isLoading: boolean;
   partnerById: typeof partnerByIdRes.data | undefined;
   monthlyCommission: typeof monthlyCommissionRes.data | undefined;
   modal: {
     result: any;
     isLoading: boolean;
     handleDelete: () => void;
     onAfterDelete: () => void;
    },
    widthHandler: {
        minWidth: string,
        width: string,
        maxWidth: string
    },

}

function RenderTableClientCommission(props: Props) {
  const {
    isLoading, monthlyCommission, partnerById, modal, widthHandler,
  } = props;

  const thLabel = React.useMemo(() => ['CLIENT', 'QUANTITY', 'AMOUNT', 'COMMISSION TYPE', 'COMMISSION'], []);

  const renderCommissionReport = () => {
    console.log('rendering commission report');
    return (
      <Table borderless responsive>
        <thead>
          <tr>
            <th style={widthHandler}>&nbsp;</th>
            {thLabel.map((th) => (
              <th className="thead-content" key={th} style={{ minWidth: '150px' }}>{th}</th>
            ))}
            <th style={widthHandler}>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {monthlyCommission && monthlyCommission.clientSales.map((clientSale) => (
            <tr key={clientSale.clientId} className="align-middle my-2 fz-14">
              <td style={widthHandler}>&nbsp;</td>
              <td>{clientSale.clientName ?? '-'}</td>
              <td>{clientSale.quantity ?? '-'}</td>
              <td>{clientSale.amount ?? '-' }</td>
              <td>{clientSale.commissionRate ?? '%' }</td>
              <td>{clientSale.totalCommission ?? '-' }</td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  };

  if (monthlyCommission && monthlyCommission.clientSales.length > 0) {
    console.log('Client Monthly Commission');
    console.log(monthlyCommission);
    return (
      <Modal.Default
        cancelLabel="Cancel"
        submitLabel="Save"
        autoShow
        title="Commission Report"
        body={renderCommissionReport()}
        onSubmitClose={modal.handleDelete}
        dialogClassName="commission-modal-width"
        isLoading={modal.isLoading}
        result={modal.result}
        onAfterResult={modal.onAfterDelete}
      />
    );
  }
  return (null);
}

export default React.memo(RenderTableClientCommission);
